
// src/web/components/diary-dropdown-menu.jsx

import React from 'react'
import { translate } from 'react-i18next'
import {
  IconMenu,
  MenuItem,
} from 'react-toolbox/lib/menu'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import { convertEmojiHTML } from '../../helpers/emoji-helpers'
import { findRoute } from '../../actions/route'
import config from '../../config'
import stripHtml from '../../helpers/strip-html'
import emoji from '../../native/assets/emoji'

function clipboardCopy(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // IE only
    window.clipboardData.setData('Text', stripHtml(text));
  }
  else {
    var input = document.createElement('div');
    input.style.position = "absolute";
    input.style.top = '-100px';
    input.style.width = '1px';
    input.style.height = '1px';
    input.innerHTML = text;
    document.body.appendChild(input);
    var range = document.createRange();
    range.selectNode(input);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    document.body.removeChild(input);
  }
}

function DiaryDropdownMenu(props) {
  const {
    t,
    diary,
    group,
    user,
    pin,
    onPin,
    translated,
    onShowOriginal,
    onShowTranslate,
    deleteDiary,
    editDiary,
    access_token,
    updateBlockDiary,
    onUnBlockConfirm,
    blockDiary
  } = props

  return (
      <IconMenu icon='more_vert' position='topRight'>
        {diary.user.user_id == user.user_id && !diary.group &&
          <MenuItem caption={t('label:投稿を編集')} onClick={editDiary} icon="mode_edit" />}
        {(diary.user.user_id == user.user_id || !diary.group && group && group.is_admin) &&
          <MenuItem caption={t('label:投稿を削除')} onClick={deleteDiary} icon="delete_forever" />}
        <MenuItem caption={t('label:投稿を印刷')} onClick={()=> window.open().location.href = `${config.baseUrl}v3/session/redirect?redirect_to=/v3/export/diary/${diary.diary_id}&access_token=${access_token}`} icon="print" />
        {!translated && <MenuItem caption={t('label:投稿を翻訳')} onClick={onShowTranslate} icon="g_translate" />}
        {translated && <MenuItem caption={t('label:元の表示に戻す')} onClick={onShowOriginal} icon="g_translate" />}
        <MenuItem caption={t('label:リンクをコピー')} onClick={()=> clipboardCopy(`${config.baseUrl}n/#/groups/${diary.group ? 'home' : group.group_id + '/timeline'}/pickup?diary_ids=${diary.diary_id}`)} icon="link" />
        <MenuItem caption={t('label:本文をコピー')} onClick={()=> clipboardCopy(convertEmojiHTML(diary.content))} icon="content_copy" />
        {blockDiary && <MenuItem caption={t('label:投稿ブロック解除')} onClick={onUnBlockConfirm} icon="do_not_disturb_on" />}
          {/* ブロック機能をeableする場合にはこのコードを使用<MenuItem caption={t('label:投稿ブロック')} onClick={() => updateBlockDiary(diary, true)} icon="block" />} */}
        {group && group.is_admin &&
          <MenuItem
            caption={pin ? t('label:ピン留め解除') : t('label:ピン留め')}
            onClick={onPin}
            icon={<img src={emoji[pin ? "1f4cc-unpin" : "1f4cc-pin"]} style={{ width: 22, height: 22, verticalAlign: 'middle' }} />} />
        }
        </IconMenu>
  )
}

export default translate()(DiaryDropdownMenu)



// WEBPACK FOOTER //
// ./src/web/components/diary-dropdown-menu.jsx